import React, { useContext } from "react";
import LanguageContext from "../utils/Contexts/LanguageContext";

function KeyboardModal() {
  const { t } = useContext(LanguageContext);

  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id="offcanvasKeyboardShortcuts"
      aria-labelledby="offcanvasKeyboardShortcutsLabel"
    >
      <div className="offcanvas-header">
        <h4 id="offcanvasKeyboardShortcutsLabel" className="mb-0">
          {t("Keyboard shortcuts")}
        </h4>
      </div>
      <div className="offcanvas-body">
        <div className="list-group list-group-sm list-group-flush list-group-no-gutters mb-5">
          <div className="list-group-item">
            <h5 className="mb-1">Formatting</h5>
          </div>
          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span className="fw-semibold">Bold</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  b
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <em>italic</em>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  i
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <u>Underline</u>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  u
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <s>Strikethrough</s>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd className="d-inline-block mb-1">Alt</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  s
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span className="small">Small text</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  s
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <mark>Highlight</mark>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  e
                </kbd>
              </div>
            </div>
          </div>
        </div>

        <div className="list-group list-group-sm list-group-flush list-group-no-gutters mb-5">
          <div className="list-group-item">
            <h5 className="mb-1">Insert</h5>
          </div>
          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>
                  {/* eslint-disable-next-line */}
                  Mention person <a href="#">(@Brian)</a>
                </span>
              </div>

              <div className="col-7 text-end">
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  @
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>
                  {/* eslint-disable-next-line */}
                  Link to doc <a href="#">(+Meeting notes)</a>
                </span>
              </div>

              <div className="col-7 text-end">
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  +
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                {/* eslint-disable-next-line */}
                <a href="#">#hashtag</a>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">#hashtag</kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Date</span>
              </div>

              <div className="col-7 text-end gap-5">
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  /date
                </kbd>
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  Space
                </kbd>
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  /datetime
                </kbd>
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  /datetime
                </kbd>
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  Space
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Time</span>
              </div>

              <div className="col-7 text-end">
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  /time
                </kbd>
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  Space
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Note box</span>
              </div>

              <div className="col-7 text-end">
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  /note
                </kbd>
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  Enter
                </kbd>
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  /note red
                </kbd>
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  /note red
                </kbd>
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  Enter
                </kbd>
              </div>
            </div>
          </div>
        </div>

        <div className="list-group list-group-sm list-group-flush list-group-no-gutters mb-5">
          <div className="list-group-item">
            <h5 className="mb-1">Editing</h5>
          </div>
          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Find and replace</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  r
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Find next</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  n
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Find previous</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  p
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Indent</span>
              </div>

              <div className="col-7 text-end">
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  Tab
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Un-indent</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Shift</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  Tab
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Move line up</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd className="d-inline-block mb-1">Shift</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  <i className="bi-arrow-up-short"></i>
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Move line down</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd className="d-inline-block mb-1">Shift</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  <i className="bi-arrow-down-short fs-5"></i>
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Add a comment</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd className="d-inline-block mb-1">Alt</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  m
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Undo</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  z
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Redo</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  y
                </kbd>
              </div>
            </div>
          </div>
        </div>

        <div className="list-group list-group-sm list-group-flush list-group-no-gutters">
          <div className="list-group-item">
            <h5 className="mb-1">Application</h5>
          </div>
          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Create new doc</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd className="d-inline-block mb-1">Alt</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  n
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Present</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd className="d-inline-block mb-1">Shift</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  p
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Share</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd className="d-inline-block mb-1">Shift</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  s
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>Search docs</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd className="d-inline-block mb-1">Shift</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  o
                </kbd>
              </div>
            </div>
          </div>

          <div className="list-group-item">
            <div className="row align-items-center">
              <div className="col-5">
                <span>{t("Keyboard shortcuts")}</span>
              </div>

              <div className="col-7 text-end">
                <kbd className="d-inline-block mb-1">Ctrl</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd className="d-inline-block mb-1">Shift</kbd>{" "}
                <span className="text-muted small">+</span>{" "}
                <kbd
                  className="d-inline-block mb-1"
                  style={{ marginRight: "5px" }}
                >
                  /
                </kbd>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KeyboardModal;
